import { Pipe, PipeTransform } from '@angular/core';
import { OccConfig } from '@spartacus/core';

@Pipe({
  name: 'baseURL',
})
export class BaseURLPipe implements PipeTransform {
  constructor(protected config: OccConfig) {}

  transform(value: string): unknown {
    return this.config.backend?.occ?.baseUrl + value;
  }
}
